import { fetchFactory } from 'isotope-client'

export const checkExport = id => fetchFactory(`/export/${id}`)

export const getLastExport = () => fetchFactory('/export/last')
